import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";
import api from "@/api/client";
import { Card } from "@/components/ui/card";
import { fmtDateTime } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

const ACTION_STYLE = {
    create: "bg-emerald-50 text-emerald-700 border-emerald-100",
    update: "bg-sky-50 text-sky-700 border-sky-100",
    delete: "bg-rose-50 text-rose-700 border-rose-100",
    login: "bg-slate-50 text-slate-600 border-slate-200",
    logout: "bg-slate-50 text-slate-600 border-slate-200",
    upload: "bg-violet-50 text-violet-700 border-violet-100",
    comment: "bg-amber-50 text-amber-700 border-amber-100",
    register: "bg-emerald-50 text-emerald-700 border-emerald-100",
    change_password: "bg-slate-50 text-slate-600 border-slate-200",
    generate_task: "bg-primary/10 text-primary border-blue-100",
};

export default function AuditLogs() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/audit").then((r) => setItems(r.data.items));
    }, []);

    return (
        <div className="space-y-6" data-testid="audit-page">
            <PageHeader title="Audit Logs" subtitle="Every important action, timestamped and immutable" />
            <Card className="overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
                            <tr>
                                <th className="text-left px-4 py-3 font-semibold">When</th>
                                <th className="text-left px-4 py-3 font-semibold">Action</th>
                                <th className="text-left px-4 py-3 font-semibold">Resource</th>
                                <th className="text-left px-4 py-3 font-semibold">User</th>
                                <th className="text-left px-4 py-3 font-semibold">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((a) => (
                                <tr key={a.id} className="border-t border-slate-100">
                                    <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{fmtDateTime(a.created_at)}</td>
                                    <td className="px-4 py-3">
                                        <span className={`badge-status ${ACTION_STYLE[a.action] || "bg-slate-50 text-slate-600 border-slate-200"}`}>
                                            {a.action}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-slate-700 capitalize">
                                        {a.resource_type} <span className="text-slate-400 font-mono text-xs">{(a.resource_id || "").slice(0, 8)}</span>
                                    </td>
                                    <td className="px-4 py-3 text-slate-600 font-mono text-xs">{(a.user_id || "").slice(0, 8)}</td>
                                    <td className="px-4 py-3 text-xs text-slate-500 max-w-md truncate">
                                        {a.details ? JSON.stringify(a.details) : ""}
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr><td colSpan={5} className="text-center py-12 text-slate-500">No activity yet.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}
